import { BottomSummaryBarV2, SummaryColumn } from '@/components/custom/erp';
import { FormFieldState } from '../../hooks';

interface BottomBarProps {
  tong_sl?: number;
  tong_tien?: number;
  tong_thue?: number;
  tong_tien_von?: number;
  tong_thanh_toan?: number;
  tong_ck?: number;
  state: FormFieldState;
}

export function BottomBar({
  tong_sl = 0,
  tong_tien = 0,
  tong_thue = 0,
  tong_tien_von = 0,
  tong_thanh_toan = 0,
  tong_ck = 0,
  state
}: BottomBarProps) {
  const ck_yn = state.ck_yn;

  const columns: SummaryColumn[] = [
    {
      className: 'min-w-[180px]',
      fields: [
        { name: 't_so_luong', label: 'Tổng số lượng', value: tong_sl, precision: 6 },
        { name: 'fixed_tax_yn', label: 'Cố định', type: 'checkbox', className: 'h-4' }
      ]
    },
    {
      className: 'min-w-[240px]',
      fields: [
        { name: 't_tien_nt2', label: 'Tổng tiền', value: tong_tien, inputClassName: 'text-right' },
        { name: 't_thue_nt', label: 'Tổng thuế', value: tong_thue, inputClassName: 'text-right' }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [
        { name: 't_tien_nt', label: 'Tổng tiền vốn', value: tong_tien_von, inputClassName: 'text-right' },
        { name: 't_ck_nt', label: 'Tổng chiết khấu', value: tong_ck, inputClassName: 'text-right', hidden: !ck_yn }
      ]
    },
    {
      className: 'min-w-[260px]',
      fields: [{ name: 't_tt_nt', label: 'Tổng thanh toán', value: tong_thanh_toan, inputClassName: 'text-right' }]
    }
  ];

  return <BottomSummaryBarV2 columns={columns} />;
}

export default BottomBar;
